import * as React from 'react';
import { SVGProps } from 'react';
/**
 * Two stacked sheets with lines of text - a brochure.
 *
 * Added for the redesigned offer page's "Download a brochure" link. The set had no document icon: pdfIcon is
 * the only near thing and it carries its own <style> block with hardcoded fills, so it ignores the colour it
 * is given and leaks its CSS into the text of whatever renders it.
 *
 * The sheet behind is drawn as its visible edges rather than a whole rectangle. A second full rectangle
 * crossing the first turns to mush at the 15px this renders at beside a line of text; only the edges that
 * actually show need to be there. Strokes rather than fills, to sit with the outline icons beside it.
 */
const SvgBrochure = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <path
      stroke={props.color}
      strokeWidth={1.4}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M5.7 4.5V1.9h9.6v11.2h-2.6"
    />
    <path
      stroke={props.color}
      strokeWidth={1.4}
      strokeLinejoin="round"
      d="M2.7 4.9h9.6v11.2H2.7z"
    />
    <path
      stroke={props.color}
      strokeWidth={1.2}
      strokeLinecap="round"
      d="M5.1 8.2h4.8M5.1 10.7h4.8M5.1 13.2h2.9"
    />
  </svg>
);
export default SvgBrochure;
